module.exports = __webpack_public_path__ + "media/common/interview-guy@2x-e46c091a.png";